<template>
    <div class="homePage">
      <div class="content">
        <div class="backgroundBox"></div>
        <div class="bcjLogoBox">
          <img src="../assets/img/bcjLogo.png" alt="">
        </div>
        <div class="backgroundBox1"></div>
        <div class="lineOne">
          <img class="bannerImg" src="../assets/img/banner@2x.png" alt="">
          <div class="lineOneContent">
            <div class="boxOne">
              <span class="boxOneText1">合作咨询〈 有关商业供应和产品功用的咨询 〉</span>
              <span class="boxOneText2">我们提供根据您的需求量身定制的产品套装和包装</span>
            </div>
            <div class="boxTwo">
  
              <span class="boxTwoText1">
                <img src="../assets/img/phoneImg1.png" alt="">
                {{ tel }}</span>
              <div class="boxTwoText2">
                <span class="btnStyle">
                  <img src="../assets/img/emailImg.png" alt="">
                  在线留言咨询
                </span>
              </div>
  
            </div>
          </div>
        </div>
        <div class="lineTwo">
  
          <div class="lineTwoRight">
            <img src="../assets/img/cursor pointer1.png" alt="">
          </div>
          <div class="lineTwoLeft">
            <div class="oneDiv">
              <div class="tip1"></div>
              <div class="tip2"></div>
            </div>
            <div class="twoDiv">
              <span class="title">关于本草纪</span>
            </div>
            <div class="threeDiv">
              <span class="title2">国内首个稻米油营养与健康研究机构</span>
            </div>
            <div class="fourDiv">
              <span class="text">
                “天生一症，地生一草克之”本草就是生命，本草就是生活。
              </span>
              <span class="text">
                本草纪（唐山）健康咨询有限公司其前身是“勃利斯糠之华商学院”，成立于2016年10月，是国内首个稻米油营养与健康研究机构。以米糠油为载体，服务客户7年，万余人。总结出米糠油不同的用法、用量、食用方法与疾病调理的关系。本着参考药典本草，论证本草功能，总结理论学术，开发本草价值为原则，自2020年开始以糠之华技术团队为班底，联合辽宁兴旺公司进行战略合作，联合专利研发并通过工艺改良和设备升级，生产出高谷、特高谷、全物理压榨稻米油并成功出口马来西亚和美国，并备案了美国FDA认证；从此正式迈入中国食用油,
                出口企业序列。
              </span>
              <span class="text">
                用科技保障食品安全，用本草服务健康中国。
              </span>
            </div>
            <div class="fiveDiv">
              <span>了解更多</span>
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
        <div class="lineThree">
          <div class="oneDiv">
            <div class="tip1"></div>
            <div class="tip2"></div>
            <div class="title">养生臻品</div>
          </div>
          <div class="twoDiv">
            <span class="title2">“本草谷物养众生，油米共生佑黎庶”，介绍米糠油的独特价值及与健康生活的紧密联系</span>
          </div>
          <div class="threeDiv">
            <div class="threeBox">
              <div class="box1" v-for="(item, index) in dataList" :key="index">
                <div class="box1Img">
                  <img :src="item.img" alt="">
                </div>
                <div class="box1text"
                  :style="{ borderLeft: index === 1 ? '.125rem solid #F8F8F8' : '', borderRight: index === 1 ? '.125rem solid #F8F8F8' : '' }">
                  <span class="titles">{{ item.title }}</span>
                  <span class="texts" style="margin-left: -0.625rem;margin-top:1.25rem">{{ item.text }}</span>
                  <span class="texts">{{ item.text2 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="lineFive">
          <span class="title">为什么选择本草纪</span>
          <div class="selectBox">
            <div class="selectDiv" v-for="(item, index) in selectList" :key="index">
              <img src="../assets/img/logo@2x.png" alt="">
              <div class="rightBox">
                <span class="titleStyle">{{ item.title }}</span>
                <span class="textStyle">{{ item.text }}</span>
              </div>
            </div>
          </div>
  
        </div>
        <div class="lineSix">
          <div class="oneDiv">
            <div>
              <span class="evaluate">他们如此评价本草纪</span>
            </div>
  
            <div class="more">
              <span>了解更多</span>
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div class="twoDiv" style="padding-bottom: 3.75rem;">
            <el-carousel class="carousel" :interval="5000" arrow="always" height="250">
              <el-carousel-item v-for="(item, index) in userList" :key="index">
                <div class="userBox">
                  <div class="userImg"></div>
                  <div class="userContent">
                    <div class="userNameBox">
                      <span class="userName">{{ item.userName }}</span>
                      <span class="remark">{{ item.userRemark }}</span>
                    </div>
                    <div class="textBox">
                      <span class="userText">{{ item.userText }}</span>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HelloWorld',
    props: {
      msg: String
    },
    data() {
      return {
        dataList: [
          { img: require('../assets/img/cursor pointer2.png'), title: '高谷稻米油', text: '“高谷金油，自然之馈，养生之道” ', text2: '精选优质稻谷，富含谷维素与天然维生素E，为您带来健康美味。' },
          { img: require('../assets/img/cursor pointer3.png'), title: '特高谷稻米油', text: '“特高谷韵，岁月沉香，健康之选” ', text2: '上等稻米胚芽提取，谷维素含量超高，抗氧化，延缓衰老理想选择。' },
          { img: require('../assets/img/cursor pointer4.png'), title: '全物理压榨稻米油', text: '“全物理压榨，纯粹如初，守护健康之源” ', text2: '全物理压榨，保留天然营养，适合各种烹饪方式，健康放心。' }
        ],
        newsDataList: [
          { img: require('../assets/img/img3-1.png'), title: '最新动态' },
          { img: require('../assets/img/img3-2.png'), title: '行业资讯' },
          { img: require('../assets/img/img3-3.png'), title: '活动信息' }
        ],
        dynamicDataList: [
          { time: '2024.06.07', type: '最新动态', typeNum: 1, text: '测试标题测试标题测试标题测试标题测试标题测试标题' },
          { time: '2024.06.07', type: '最新动态', typeNum: 1, text: '测试标题测试标测试标题' },
          { time: '2024.06.07', type: '行业资讯', typeNum: 2, text: '测试标题测试试标题测试标题测试标题测试标题测试标题测试标题测试标题测试标题' },
          { time: '2024.06.07', type: '行业资讯', typeNum: 2, text: '测试标题测试标题测试标题测试题测试标题测试标题测试标题' },
          { time: '2024.06.07', type: '活动信息', typeNum: 3, text: '测试标标题测试标标题测试标题测试标题测试标题' },
          { time: '2024.06.07', type: '活动信息', typeNum: 3, text: '测试标题测试标题测测试标题测试标题测试标题' }
        ],
        selectList: [
          { title: '专业性与深厚的研究基础', text: '本草纪在稻米油营养与健康领域拥有深厚的研究基础。选择本草纪，就是选择了专业与深入的行业知识。' },
          { title: '高质量的产品与创新能力', text: '经联合研发、工艺改良和设备升级，生产出高品质稻米油，已成功出口并获FDA认证。' },
          { title: '以人类健康为己任的企业使命', text: '秉承自然法则和爱人理念，致力与研究与开发本草，其强烈的社会责任感深得人心。' }
        ],
        userList: [
          { userImg: '', userName: '张总团队', userRemark: '唐山某某企业', userText: '本草纪公司给我留下了非常深刻的印象。他们不仅专业致力于本草的研究与开发，更难得的是，他们以人类健康事业为己任，始终坚守自然法则，秉持着敬天爱人的经营理念。这种对社会责任的强烈担当，让我对本草纪的产品和服务充满了信任。从他们的全物理压榨稻米油就可以看出，本草纪在产品质量和创新方面都有着不俗的实力。我相信，选择本草纪，就是选择了一个值得信赖的伙伴。' }
  
        ],
        tel: "400-1535-345",
      };
  
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">
  .backgroundBox {
    width: 36rem;
    height: 12.5rem;
    background: #F8F8F8;
    border: 0rem solid #000000;
    position: absolute;
    top: 56.875rem
  }
  
  .bcjLogoBox {
    position: absolute;
    top: 83.75rem;
    right: 0rem;
  
    img {
      width: 48.9375rem;
      height: 17.25rem;
    }
  
  }
  
  .backgroundBox1 {
    width: 89.375rem;
    height: 49.75rem;
    background: #F8F8F8;
    border: 0rem solid #000000;
    position: absolute;
    top: 101.25rem;
    right: 0rem;
  }
  
  ::v-deep .el-carousel--horizontal {
  
    margin-left: 17.75rem;
    margin-top: 2.5rem;
    width: 83.75rem;
    box-shadow: .5rem .625rem 1.125rem 0rem #A0A4AA;
    border-radius: .625rem;
  
    .el-carousel__arrow {
      width: 2.5rem;
      height: 2.5rem;
      font-size: 1.25rem;
    }
  
    .el-carousel__button {
      width: 1.625rem;
      height: .25rem;
      background: #F2F2F2;
    }
  
    .is-active {
      .el-carousel__button {
        width: 1.625rem;
        height: .25rem;
        background: #009B75;
      }
    }
  
    .userBox {
      padding-top: 3.125rem;
      padding-left: 9.375rem;
      background: #FFFFFF;
      height: 18.75rem;
      display: flex;
  
      .userImg {
        width: 6.25rem;
        height: 6.25rem;
        border-radius: 50%;
        margin-right: 1.875rem;
        background: #EDF1F0
      }
  
      .userContent {
        .userNameBox {
          .userName {
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            font-size: 1.25rem;
            color: #2C2D31;
            line-height: 2.5rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
  
          NaNpxark {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .875rem;
            color: #ABADB0;
            line-height: 2.5rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin-left: .625rem
          }
        }
  
        .textBox {
          margin-top: .625rem;
  
          .userText {
            display: block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 1rem;
            color: #2E3640;
            line-height: 1.875rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
            width: 55.9375rem;
  
          }
        }
      }
    }
  }
  
  .homePage {
    width: 120rem;
    margin: 0 auto;
  }
  
  .fontColr1 {
    color: #fff !important;
    border: .0625rem solid #fff !important
  }
  
  .fontColr2 {
    color: rgb(183, 210, 141) !important;
    border: .0625rem solid rgb(183, 210, 141) !important
  }
  
  .fontColr3 {
    color: rgb(115, 223, 206) !important;
    border: .0625rem solid rgb(115, 223, 206) !important
  }
  
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 3.125rem;
    color: #2E3640;
    line-height: 3.25rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  
  .title2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 1.75rem;
    color: rgb(209, 209, 209);
    line-height: 2rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  
  .text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 1.125rem;
    color: #2E3640;
    line-height: 2.5rem;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
  }
  
  .content {
    background: #fff;
    position: relative;
  }
  
  .lineOne {
    text-align: center;
  
    .bannerImg {
      width: 120rem;
      height: 43.4375rem;
    }
  
    .lineOneContent {
      margin: -4.375rem 17.75rem 0 17.75rem;
      padding: 1.875rem 3.75rem;
      height: 11.125rem;
      background: #009B75;
      border-radius: .25rem .25rem .25rem .25rem;
      opacity: 0.8;
  
      .boxOne {
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 1.625rem;
        font-style: normal;
        text-transform: none;
        padding-bottom: 1.25rem;
        border-bottom: .0625rem solid #FFFFFF;
  
        .boxOneText1 {
          font-size: 1.5rem;
          letter-spacing: .25rem;
        }
  
        .boxOneText2 {
          font-size: .75rem;
          letter-spacing: .125rem;
        }
      }
  
      .boxTwo {
        height: 9.375rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 1.625rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
  
        .boxTwoText1 {
          font-size: 2.25rem;
          font-size: 2.25rem;
          margin-top: 3.75rem;
          display: inline-block;
          margin-left: 10.625rem;
  
          img {
            width: 1.75rem;
            height: 1.75rem;
            margin-right: 1.25rem
          }
        }
  
        .boxTwoText2 {
          height: 6.25rem;
          border-left: .0625rem solid #fff;
          margin-left: 10rem;
          padding-left: 7.5rem;
          position: relative;
          top: -0.4375rem;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
        }
  
        .btnStyle {
          font-size: 1.125rem;
          color: #009B75;
          width: 22.5625rem;
          height: 3.375rem;
          background: #FFFFFF;
          border-radius: .5rem .5rem .5rem .5rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
  
          img {
            width: 1.125rem;
            height: .875rem;
            margin-right: 2.5rem;
          }
        }
  
      }
    }
  }
  
  .lineTwo {
  
  
    margin-top: 5rem;
    margin-left: 17.75rem;
    margin-right: 17.75rem;
    display: flex;
  
    .lineTwoRight {
      margin-right: 3.5625rem;
      z-index: 999;
  
      img {
        width: 31.25rem;
        height: 38.125rem
      }
    }
  
    .lineTwoLeft {
      z-index: 9999;
  
      .oneDiv {
        display: flex;
  
        .tip1 {
          width: 1rem;
          height: 1rem;
          background: #009B75;
          border: 0rem solid #000000;
        }
  
        .tip2 {
          width: 1rem;
          height: 1rem;
          background: #604D3D;
          border: 0rem solid #000000;
          margin-left: .9375rem
        }
      }
  
      .twoDiv {
        margin-top: 1.875rem;
      }
  
      .threeDiv {
        margin-top: 1.6875rem;
      }
  
      .fourDiv {
        margin-top: 2.375rem;
  
        span {
          display: block;
        }
      }
  
      .fiveDiv {
        display: flex;
        margin-top: 3.5625rem;
        width: 8.75rem;
        height: 1.875rem;
        border-bottom: .0625rem solid #009B75;
        justify-content: space-between;
        cursor: pointer;
  
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 1.125rem;
          color: #009B75;
          line-height: .375rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
  
        }
  
        i {
          font-size: 1.125rem;
          color: #009B75;
          margin-top: -0.375rem;
        }
      }
    }
  }
  
  .lineThree {
    position: relative;
    .oneDiv {
      display: flex;
      align-items: center;
      margin-top: 7.125rem;
      margin-left: 17.8125rem;
  
      .tip1 {
        width: 1rem;
        height: 1rem;
        background: #009B75;
        border: 0rem solid #000000;
      }
  
      .tip2 {
        width: 1rem;
        height: 1rem;
        background: #604D3D;
        border: 0rem solid #000000;
        margin-left: .9375rem
      }
  
      .title {
        margin-left: 1.875rem
      }
    }
  
    .twoDiv {
      margin-left: 17.8125rem;
      margin-top: 1.6875rem;
    }
  
    .threeDiv {
      margin-left: 12.5rem;
      margin-top: 4.125rem;
     
  
      .threeBox {
        background: rgb(255, 255, 2255);
        display: flex;
        width: 95rem;
        box-shadow: .5rem .625rem 1.125rem 0rem #A0A4AA;
        .box1 {
  
  
  
          .box1Img {
            img {
              width: 100%;
              height: 100%;
            }
  
          }
  
          .box1text {
            padding: 1.875rem;
  
            .titles {
              display: block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 1.375rem;
              color: #2E3640;
              line-height: 2.625rem;
              text-align: justifyLeft;
              font-style: normal;
              text-transform: none;
            }
  
            .texts {
              display: block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: .75rem;
              color: #2E3640;
              line-height: 2.5rem;
              text-align: justifyLeft;
              font-style: normal;
              text-transform: none;
            }
          }
        }
      }
    }
  }
  
  .lineFour {
    background-image: url('../assets/img/news1.png');
    background-size: 120rem 43.9375rem;
    background-repeat: no-repeat;
    height: 33.9375rem;
    padding: 5rem 17.75rem;
    margin-top: 5rem;
  
    .oneDiv {
      display: flex;
      align-items: center;
      justify-content: space-between;
  
      .rightBox {
        display: flex;
        align-items: center;
  
        .tip1 {
          width: 1rem;
          height: 1rem;
          background: #009B75;
          border: 0rem solid #000000;
        }
  
        .tip2 {
          width: 1rem;
          height: 1rem;
          background: #fff;
          border: 0rem solid #000000;
          margin-left: .9375rem
        }
  
        .title {
          margin-left: 1.875rem;
        }
      }
  
      .leftBox {
        display: flex;
        width: 8.75rem;
        height: 1.875rem;
        border-bottom: .0625rem solid #FFFFFF;
        justify-content: space-between;
        cursor: pointer;
  
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 1.125rem;
          color: #FFFFFF;
          line-height: .375rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
  
        }
  
        i {
          font-size: 1.125rem;
          color: #FFFFFF;
          margin-top: -0.375rem;
        }
      }
    }
  
    .twoDiv {
      margin-top: 5rem;
      display: flex;
  
      .imgBox {
        padding: 1.25rem;
        background: rgb(112, 95, 81);
        border-radius: .5rem;
        width: 24.5rem;
        display: flex;
        align-items: center;
  
        img {
          width: 6.25rem;
          height: 6.25rem;
          border-radius: .5rem;
        }
  
        .imgText {
          margin-left: 1.25rem;
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 1.375rem;
          color: #fff;
          line-height: 2.625rem;
          text-align: justifyLeft;
          font-style: normal;
          text-transform: none;
        }
  
        i {
          font-size: 1.125rem;
          color: #fff;
          margin-top: -0.375rem;
          position: relative;
          right: -10.625rem;
        }
      }
    }
  
    .threeDiv {
      margin-top: 5rem;
  
      .flexBox {
        display: flex;
        flex-wrap: wrap;
        width: 100rem;
  
        .flex {
          margin: .625rem 0rem;
          width: 39.1875rem;
          display: flex;
          align-items: center;
  
          .timeText {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .875rem;
            color: #fff;
            line-height: 1.75rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
  
          .typeText {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .75rem;
            color: #fff;
            line-height: 1.75rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin: 0 1.25rem;
            border: .0625rem solid #fff;
            padding: .125rem 1.25rem;
          }
  
          .textText {
            display: inline-block;
            width: 26.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .875rem;
            color: #fff;
            line-height: 1.75rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
            overflow: hidden;
            /* 确保超出容器的文本被裁剪 */
            white-space: nowrap;
            /* 防止文本换行 */
            text-overflow: ellipsis;
            /* 用省略号显示被裁剪的文本 */
          }
        }
      }
    }
  }
  
  .lineFive {
    background-image: url('../assets/img/selectImg.png');
    background-size: 120rem 25rem;
    background-repeat: no-repeat;
    height: 16.4375rem;
    padding: 4.375rem 17.75rem;
    text-align: center;
  
    .selectBox {
      display: flex;
      justify-content: space-between;
      margin-top: 3.75rem;
  
      .selectDiv {
        display: flex;
        background: #fff;
        border-radius: .625rem;
        padding: 1.25rem;
        box-shadow: .5rem .625rem 1.125rem 0rem #A0A4AA;
  
        img {
          width: 4.625rem;
          height: 4.375rem;
          margin-right: 1.25rem;
        }
  
        .rightBox {
          width: 16.5625rem;
  
          .titleStyle {
            display: block;
            text-align: left;
            display: block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 1.125rem;
            color: #2E3640;
            line-height: 2.625rem;
            font-style: normal;
            text-transform: none;
          }
  
          .textStyle {
            display: block;
            text-align: left;
            font-size: .75rem;
            width: 12.5rem;
            line-height: 1.5rem;
          }
        }
      }
    }
  
  }
  
  .lineSix {
    padding-top: 3.125rem;
  
    .oneDiv {
      text-align: center;
      width: 83.75rem;
      margin: 0 auto;
  
      .evaluate {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 1.5rem;
        color: #2E3640;
        line-height: 1.5rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
  
      .more {
        text-align: justify;
        float: right;
        display: inline-block;
        width: 8.75rem;
        height: 1.875rem;
        border-bottom: .0625rem solid #009B75;
        justify-content: space-between;
        cursor: pointer;
        margin-top: -1.5rem;
  
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 1.125rem;
          color: #009B75;
          line-height: .375rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
  
        }
  
        i {
          font-size: 1.125rem;
          color: #009B75;
          margin-top: -0.375rem;
        }
      }
  
      .twoDiv {
        padding-bottom: 3.125rem;
      }
    }
  }
  </style>